import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatCheckboxLabel'
})
export class FormatCheckboxLabelPipe implements PipeTransform {

  transform(value: string): string {
    let label = value.replace(/([A-Z]+)/g, ' $1');
    label = label.charAt(0).toUpperCase() + label.slice(1);
    if (label.includes('Percentuale')) {
      label = label.replace('Percentuale', '%');
    }
    if (label.includes('Rendimento')) {
      label = label.replace('Rendimento', 'Rendim.');
    }
    return label;
  }

}
